

/** 条件类 */ 
export namespace ConditionKind {

     /** 条件数据 */
     export class ConditionResult {
        /** 当前值 */
        cValue: number = 0;
        /** 目标值 */
        tValue: number = 1;
        
        isFinish() {
            return this.cValue >= this.tValue;
        }

        progress() {
            return this.cValue / this.tValue;
        }
    }
    
    /** 条件类型 */ 
    export enum ConditionsType {
        /** 等级达到 */
        LEVEL = 'level',
        /** 打开漕运界面  */
        OPEN_WATER_RUN = 'open_water_run',
    }
}